<template>
  <div class="mainContainer">
    <el-form ref="ywForm" :model="studentEyesightInfo" label-width="120px">
      <el-form-item label="流水号：" >
        <el-input v-model="studentEyesightInfo.serialNo" disabled></el-input>
      </el-form-item>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="地区：" >
            <el-input v-model="studentEyesightInfo.countyname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学校：" >
            <el-input v-model="studentEyesightInfo.graduateschool"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">

        </el-col>
        <el-col :span="12">

        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="年级：" >
            <el-input v-model="studentEyesightInfo.gradename"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班级：" >
            <el-input v-model="studentEyesightInfo.classcode"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="姓名：" >
            <el-input v-model="studentEyesightInfo.bname"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性别：" >
            <el-radio-group v-model="studentEyesightInfo.gender">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="民族：" >
            <el-select v-model="studentEyesightInfo.nationcode" placeholder="请选择民族" size="mini"
                       style="width: 130px;">
              <el-option
                  v-for="item in nations"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="s-border tc">
        <el-col :span="4" class="srb">-</el-col>
        <el-col :span="10" class="srb">左眼</el-col>
        <el-col :span="10">右眼</el-col>
      </el-row>
      <el-row :gutter="10" class="s-border tc">
        <el-col :span="4" class="srb">裸眼视力</el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.nakedlefteye"></el-input>
        </el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.nakedrighteye"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="s-border tc">
        <el-col :span="4" class="srb">屈光球镜S</el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.leftobs"></el-input>
        </el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.rightobs"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="s-border tc">
        <el-col :span="4" class="srb">屈光柱镜C</el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.leftopc"></el-input>
        </el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.rightopc"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="s-border tc">
        <el-col :span="4" class="srb">屈光轴位A</el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.leftoaa"></el-input>
        </el-col>
        <el-col :span="10" class="srb">
          <el-input v-model="studentEyesightInfo.rightoaa"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="8" class="s-border tc" >
        <el-col :span="12" class="srb">
          角膜塑形镜（OK镜）佩戴者
          <el-switch
              v-model="studentEyesightInfo.ceratoscope"
              active-color="#13ce66"
              inactive-color="#909399"
              active-value="是"
              inactive-value="否">
          </el-switch>
        </el-col>
        <el-col :span="12" class="margin-bfb" >
          戴镜情况：
          <el-radio-group v-model="studentEyesightInfo.glasscase">
            <el-radio :label="0">未戴</el-radio>
            <el-radio :label="1">框架镜</el-radio>
            <el-radio :label="2">隐形镜</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-form-item style="margin-top: 8px;">
        <el-button @click="cancleEdit">取消</el-button>
        <el-button type="primary" @click="editStudentInfo">修改</el-button>

      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "EmpEyesightEdit",
  data() {
    return {
      studentEyesightInfo: {},
      nations:[]
    }
  },
  created() {
    console.log("加载民族信息")
    this.initNations()
  },
  mounted() {
    this.initStudentInfo(this.$route.query.studentId)
  },
  methods: {
    cancleEdit(){
      this.studentEyesightInfo = {}
      this.$router.go(-1)
    },
    editStudentInfo(){
      let parasms = {
        ...this.studentEyesightInfo
      }
      this.postRequest("/employee/basic/updateEyesightInfo",parasms).then(({data}) => {
        if(data){
          this.$message.success("更新成功！")
          this.$router.go(-1)

        }
      }).catch(e => console.log("更新学生信息失败！",e.message))
    },
    initNations(){
      this.getRequest("/employee/basic/nations").then(({data}) => {
        this.nations = data
      }).catch(e => console.log("加载学生民族信息失败！",e.message))

    },
    initStudentInfo(studentId){
      let qurtyParam = {
        studentId:studentId
      }
      this.getRequest("/employee/basic/getEyesightById", {params: qurtyParam}).then(({data}) => {
        this.studentEyesightInfo = data
        console.log(" == > ",this.studentEyesightInfo )
      }).catch(e => console.log("加载学生检查视力信息失败！",e.message))
    }
  }
}
</script>

<style scoped>
.mainContainer {
  width: 98%;
  height: calc(100vh - 150px);
  padding: 8px;
  background-color: #f2f2f3;
}

.s-border {
  border: 1px solid black;
}
.tc {
  text-align: center;
}
.srb {
  border-right: 1px solid black;
}
</style>